"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmbassadorConsentStatus = void 0;
var AmbassadorConsentStatus;
(function (AmbassadorConsentStatus) {
    AmbassadorConsentStatus["NOT_ASKED"] = "NOT_ASKED";
    AmbassadorConsentStatus["DENIED"] = "DENIED";
    AmbassadorConsentStatus["ACCEPTED"] = "ACCEPTED";
})(AmbassadorConsentStatus || (exports.AmbassadorConsentStatus = AmbassadorConsentStatus = {}));
